/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 8/3/2022 下午 4:21 下午 1:57 🚌🚄🚈🚝 */
<template>
	<div>
		<el-form :model="form" label-width="120" :rules="rules" ref="formName">
			<el-form-item label="学校" prop="schoolId">
				<el-radio-group v-model="form.schoolId">
					<el-radio :label="item.schoolId" v-for="item in schoolSubjectInfo.schoolInfo" :key="item.schoolId" @change="selSchool(item.schoolName)">{{
						item.schoolName
					}}</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="学科" prop="subjectId">
				<el-radio-group v-model="form.subjectId">
					<el-radio :label="item.pkId" v-for="item in schoolSubjectInfo.subjectInfo" :key="item.pkId" @change="selSubName(item.subName)">{{
						item.subName
					}}</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="班级" v-show="classIdList.length > 0" prop="classId">
				<el-radio-group v-model="form.classId">
					<el-radio :label="item.classId" v-for="item in classIdList" :key="item.classId" @change="selClassName(item.className)">{{
						item.className
					}}</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="quit">取 消</el-button>
			<el-button type="primary" @click="confirm">确 定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'temp',
	data() {
		return {
			form: {
				schoolId: '',
				subjectId: '',
				classId: '',
				schoolName: '',
				subName: '',
				className: ''
			},
			rules: {
				schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
				subjectId: [{ required: true, message: '请选择学科', trigger: 'change' }],
				classId: [{ required: true, message: '请选择班级', trigger: 'change' }]
			},
			query: this.$route.query,
			schoolSubjectInfo: {},
			classIdList: []
		}
	},
	watch: {
		form: {
			handler(val) {
				if (val.schoolId !== '' && val.subjectId !== '') {
					this.getClassInfo()
				}
			},
			deep: true
		}
	},
	created() {
		this.getBasicInfo()
	},
	methods: {
		selSchool(val) {
			this.schoolName = val
		},
		selSubName(val) {
			this.subName = val
		},
		selClassName(val) {
			this.className = val
		},
		// 学校。 学科
		getBasicInfo() {
			const params = { examId: this.query.examId }
			this.$post('knowledgeSubjectConfig/queryExamInfo', params).then(res => {
				this.$emit('mySchoolName', res.data.examInfo.examName)
				this.schoolSubjectInfo = res.data
			})
		},
		//班级
		getClassInfo() {
			const params = { examId: this.query.examId, ...this.form }
			this.$post('knowledgeSubjectConfig/querySchoolClassInfo', params).then(res => {
				this.classIdList = res.data
				this.classIdList.unshift({ classId: '0', className: '全部' })
			})
		},
		// 取消
		quit() {
			this.$emit('input', false)
		},
		// 确定
		confirm() {
			this.$refs.formName.validate(valid => {
				if (valid) {
					this.$emit('input', false)
					this.$emit('subConfirm', this.form)
					this.$emit('basicInfo', `学校：${this.schoolName}，科目：${this.subName}，班级：${this.className}`)
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.dialog-footer {
	display: flex;
	justify-content: center;
}
</style>
